import { render, staticRenderFns } from "./LoginStrategy.vue?vue&type=template&id=08bc5dbe&scoped=true&"
import script from "./LoginStrategy.vue?vue&type=script&lang=js&"
export * from "./LoginStrategy.vue?vue&type=script&lang=js&"
import style0 from "./LoginStrategy.vue?vue&type=style&index=0&id=08bc5dbe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc5dbe",
  null
  
)

export default component.exports